import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VuejsDatatableFactory } from 'vuejs-datatable';
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import './assets/css/style.css'

import 'vue2-datepicker/locale/es';

import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(VueLoading);


import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import JsonViewer from 'vue-json-viewer/ssr'
import 'vue-json-viewer/style.css'
Vue.use(JsonViewer)

import { io } from "socket.io-client";

Vue.prototype.$socket = io("https://localhost:3000/romana", {
    //withCredentials: true,
    /* extraHeaders: {
        "my-custom-header": "abcd"
    } */
    autoConnect: false
});


import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
Vue.component('datetime', Datetime);

import { mapState } from 'vuex'

Vue.component('DatePicker', DatePicker);


Vue.component('v-select', vSelect)

Vue.component('multiselect', Multiselect)

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
    moment
})
////console.log(Vue.moment().locale())
//Vue.use(require('vue-moment'));

var $ = require('jquery');

Vue.filter('fecha_hora', function (valor) {
    if (!valor) return ''
    let result = Vue.moment(valor);
    return result.isValid() ? result.format('DD/MM/YYYY HH:mm') : valor;
})

Vue.filter('fecha', function (valor) {
    //console.log("valor_fecha",valor)
    if (!valor) return ''

    let result = Vue.moment(valor);
    return result.isValid() ? result.format('DD/MM/YYYY') : valor;

})

Vue.filter('hora', function (valor) {
    if (!valor) return ''
    let result = Vue.moment(valor);
    return result.isValid() ? result.format('HH:mm') : valor;
})

Vue.filter('formatear_miles', function (valor) {
    if (!valor) return '0'
    if (typeof valor == 'string') {

        valor = Number(valor);
    }
    let result = valor.toLocaleString("es-CL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return result;
})

Vue.filter('formatear_miles2', function (valor) {
    if (!valor) return ''
    if (typeof valor == 'string') {

        valor = Number(valor);
    }
    let result = valor.toLocaleString("es-CL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return result;
})

/* Vue.prototype.$verificar_rol = function(rol){
    //console.log('rol:'+rol);
    return false;
} */

Vue.mixin({
    methods: {
        verificar_permiso: function (permiso) {
            let permisos = store.state.permisos_rom;
            let idx = permisos.findIndex(p => p == permiso);
            //console.log('verificar_rol: '+rol);
            return idx == -1 ? false : true;
        },
    }
})

/* VuejsDatatableFactory.useDefaultType( false )
    .registerTableType( 'datatable', tableType => tableType.mergeSettings( {
        table: {
            class:   'table table-flush thead-light',
            sorting: {
                sortAsc:  '<i class="fas fa-sort-amount-up" title="Sort ascending"></i>',
                sortDesc: '<i class="fas fa-sort-amount-down" title="Sort descending"></i>',
                sortNone: '<i class="fas fa-sort" title="Sort"></i>',
            },
        },
        pager: {
            classes: {
                pager:    'pagination',
                selected: 'active',
                li:'paginate_button page-item page-link'
            },
            icons: {
                next:     '<i class="fas fa-chevron-right" title="Next page"></i>',
                previous: '<i class="fas fa-angle-left" title="Previous page"></i>',
            },
        },
    } ) ); */

/* Vue.use( VuejsDatatableFactory ); */

Vue.use(VueAxios, axios)

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    //console.log('aquiiiiiiiiiiiii', error.response.status);
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    //alert("Ha ocurrido un error en el sistema, favor comunicarse con desarrollo@pcgeek.cl");
    if (error.response.status == 401) {
        store.dispatch('cerrar_sesion');
        //window.location = '/login';
        router.push({path:'/login'})
        Promise.resolve();
    } else {
        return Promise.reject(error);
    }
    // Do something with response error
    //return Promise.reject(error);
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || process.env.NODE_ENV === 'production' ? 'ROMANA V2' : 'ROMANA DEVELOP';
            }
        },
    }
}).$mount('#app')
